import { c as _c } from "react/compiler-runtime";
import { Fragment } from 'react';
import Text from '@/app/cc/_component/ui/common/Text/Text';
import styles from '@/app/cc/_component/ui/section/Differences/Differences.module.scss';

// ─── 데이터 타입 ──────────────────────────────────────────────────

type GeneralData = {
  kind: 'highlighted';
  before: string;
  highlight: string;
} | {
  kind: 'with-subtext';
  text: string;
  subText: string;
} | {
  kind: 'plain';
  text: string;
};
type SafeCareData = {
  kind: 'two-tone';
  outerText: string;
  highlightText: string;
} | {
  kind: 'primary';
  lines: string[];
  variant?: 'm1' | 'm2';
  subText?: string;
  noBorderBottom?: boolean;
};
interface TableRowData {
  label: string;
  general: GeneralData;
  safeCare: SafeCareData;
}

// ─── 테이블 데이터 ────────────────────────────────────────────────

const TABLE_DATA: TableRowData[] = [{
  label: '보장 시점',
  general: {
    kind: 'highlighted',
    before: '사고 발생 ',
    highlight: '이후'
  },
  safeCare: {
    kind: 'two-tone',
    outerText: '안심케어 신청',
    highlightText: '직후부터'
  }
}, {
  label: '가짜 임대인/매도인',
  general: {
    kind: 'with-subtext',
    text: '보장 불가',
    subText: '(계약 무효)'
  },
  safeCare: {
    kind: 'primary',
    lines: ['실손금 보상'],
    subText: '(보험가입금액 범위 내)'
  }
}, {
  label: '법적 분쟁 비용',
  general: {
    kind: 'with-subtext',
    text: '본인 부담',
    subText: '(수백만원)'
  },
  safeCare: {
    kind: 'primary',
    lines: ['변호사 선임', '비용 지원'],
    subText: '(보험가입금액 범위 내)'
  }
}, {
  label: '등기 변동 알림',
  general: {
    kind: 'plain',
    text: '지원 안 함'
  },
  safeCare: {
    kind: 'primary',
    lines: ['실시간', '카톡 알림'],
    variant: 'm2',
    noBorderBottom: true
  }
}];

// ─── 렌더링 컴포넌트 ──────────────────────────────────────────────

function GeneralCell(t0) {
  const $ = _c(11);
  const {
    data
  } = t0;
  if (data.kind === "highlighted") {
    let t1;
    if ($[0] !== data.highlight) {
      t1 = <Text as="span" category="heading" variant="m2" color="var(--color-red-500)">{data.highlight}</Text>;
      $[0] = data.highlight;
      $[1] = t1;
    } else {
      t1 = $[1];
    }
    let t2;
    if ($[2] !== data.before || $[3] !== t1) {
      t2 = <Text as="span" category="heading" variant="m2" color="var(--color-gray-400)">{data.before}{t1}</Text>;
      $[2] = data.before;
      $[3] = t1;
      $[4] = t2;
    } else {
      t2 = $[4];
    }
    return t2;
  }
  if (data.kind === "with-subtext") {
    let t1;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <br className="break" />;
      $[5] = t1;
    } else {
      t1 = $[5];
    }
    let t2;
    if ($[6] !== data.subText || $[7] !== data.text) {
      t2 = <Text as="span" category="heading" variant="m2" color="var(--color-gray-400)">{data.text}{t1} {data.subText}</Text>;
      $[6] = data.subText;
      $[7] = data.text;
      $[8] = t2;
    } else {
      t2 = $[8];
    }
    return t2;
  }
  let t1;
  if ($[9] !== data.text) {
    t1 = <Text as="span" category="heading" variant="m2" color="var(--color-gray-400)">{data.text}</Text>;
    $[9] = data.text;
    $[10] = t1;
  } else {
    t1 = $[10];
  }
  return t1;
}
function SafeCareCell(t0) {
  const $ = _c(22);
  const {
    data
  } = t0;
  if (data.kind === "two-tone") {
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <br className="break" />;
      $[0] = t1;
    } else {
      t1 = $[0];
    }
    let t2;
    if ($[1] !== data.highlightText) {
      t2 = <Text as="span" category="heading" variant="m1" color="var(--color-primary-500)">{data.highlightText}</Text>;
      $[1] = data.highlightText;
      $[2] = t2;
    } else {
      t2 = $[2];
    }
    let t3;
    if ($[3] !== data.outerText || $[4] !== t2) {
      t3 = <div className={styles.tableRightinner}><Text as="span" category="heading" variant="m1" color="var(--color-gray-700)">{data.outerText} {t1}{t2}</Text></div>;
      $[3] = data.outerText;
      $[4] = t2;
      $[5] = t3;
    } else {
      t3 = $[5];
    }
    return t3;
  }
  const {
    lines,
    variant: t1,
    subText,
    noBorderBottom
  } = data;
  const variant = t1 === undefined ? "m1" : t1;
  let t2;
  if ($[6] !== noBorderBottom) {
    t2 = noBorderBottom ? {
      borderBottom: "none"
    } : undefined;
    $[6] = noBorderBottom;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[8] !== lines) {
    t3 = lines.map(_temp);
    $[8] = lines;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] !== subText) {
    t4 = subText && <br />;
    $[10] = subText;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] !== t3 || $[13] !== t4 || $[14] !== variant) {
    t5 = <Text as="span" category="heading" variant={variant} color="var(--color-primary-500)">{t3}{t4}</Text>;
    $[12] = t3;
    $[13] = t4;
    $[14] = variant;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  let t6;
  if ($[16] !== subText) {
    t6 = subText && <Text as="span" category="caption" variant="m2" color="var(--color-gray-600)">{subText}</Text>;
    $[16] = subText;
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  let t7;
  if ($[18] !== t2 || $[19] !== t5 || $[20] !== t6) {
    t7 = <div className={styles.tableRightinner} style={t2}>{t5}{t6}</div>;
    $[18] = t2;
    $[19] = t5;
    $[20] = t6;
    $[21] = t7;
  } else {
    t7 = $[21];
  }
  return t7;
}

// ─── 메인 컴포넌트 ────────────────────────────────────────────────
function _temp(line, i) {
  return <Fragment key={line}>{i > 0 && <br className="break" />}{line}</Fragment>;
}
export default function DifferencesTable() {
  const $ = _c(4);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className={styles.tableHeaderEmpty} />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className={styles.tableHeader}>{t0}<div className={styles.tableHeaderItem}><Text as="span" category="heading" variant="sb1" color="var(--color-gray-700)">일반 반환 보증<br className="break" /> (HUG 등)</Text></div><div className={styles.tableHeaderItem} /></div>;
    t2 = TABLE_DATA.map(_temp2);
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className={styles.differencesTable}>{t1}{t2}<div className={styles.tableRight}><div className={styles.tableRightTitle}><Text as="span" category="title" variant="b3" color="var(--color-gray-0)">이실장<br className="break" /> 안심케어</Text></div>{TABLE_DATA.map(_temp3)}</div></div>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  return t3;
}
function _temp3(item_0) {
  return <div className={styles.tableRightContent} key={`${item_0.label}-r`}><div className={styles.tableRightContentPadding}><SafeCareCell data={item_0.safeCare} /></div></div>;
}
function _temp2(item) {
  return <div className={styles.tableLeft} key={item.label}><div className={styles.tableLeftTitle}><Text as="span" category="heading" variant="sb2" color="var(--color-gray-700)">{item.label}</Text></div><div className={styles.tableLeftContent}><GeneralCell data={item.general} /></div><div className={styles.tableLeftEmpty} /></div>;
}